import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export class TokenRawHandler implements HttpHandler {
    constructor(private next: HttpHandler) { }

    handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
        const token = localStorage.getItem("Progreso.authorizationData");

        if (!token) {
            return this.next.handle(req);
        }

        const authReq = req.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
        });

        return this.next.handle(authReq);
    }
}
